import axios from 'axios';

import { env } from 'config';

export type GatewayAppConfigs = {
  sberQrBankBic: Record<string, string>;
};

const getGatewayConfigs = async (): Promise<GatewayAppConfigs> =>
  (await axios.get(`${env.apiUrl}/v1/app-configs/gateway`)).data;

export const appConfigsApi = {
  getGatewayConfigs,
};
